import {Header} from "../components/Header";
import {Footer} from "../components/Footer";
import {Fade, Slide} from "react-awesome-reveal";
import {TextInput} from "../modules/TextInput";
import {Button} from "../modules/Button";
import {
  isIOS,
  isPc,
  savePageVisit,
  SCREEN_WIDTH,
  sendFormRequest,
  sendRequest,
  validateEmail, validatePhone
} from "../static/js/common";
import {useEffect, useRef, useState} from "react";
import Modal from "react-modal";


const FileInput = ({fileRef, files, setFiles, msg, desc}) => {

  return (
    <div className={'flex-column'}>
      <div className={`flex-row`} onClick={() => fileRef?.current?.click()}>
        <div className={'file-box align-center'}>
          {/*accept={'application/pdf'} */}
          <input ref={fileRef} type={'file'} style={{display: 'none'}} onChange={e => {
            if (files?.length > 2) {
              alert('파일은 3개까지만 등록할 수 있습니다.')
              return
            }
            const file_ = e?.target.files[0]
            if (file_?.size > 50 * 1024 * 1024) {
              alert('파일 용량은 50MB 이하로 업로드 해주세요.')
              return
            }
            files.push(file_)
            setFiles(Object.assign([], files))
          }}/>
          <img className={'icon-32'} src={require('../assets/images/attachment.png')}/>
        </div>
        <div className={'margin-left-20 text-center'}>
          <div className={'white font-24'}>{msg}</div>
          <div className={'more-blur-white font-16 margin-top-10'}>{desc}</div>
        </div>
      </div>
      <div className={'margin-top-20'}>
        {files?.map((item, index) => {
          return (
            <div className={'white font-20 margin-left-20'}>{item?.name}</div>
          )
        })}
      </div>
    </div>
  )
}

const MobileFileInput = ({fileRef, files, setFiles, msg, desc}) => {
  return (
    <div className={`align-center flex-column`} onClick={() => fileRef?.current?.click()}>
      <div className={'file-box align-center'}>
        {/*accept={'application/pdf'} */}
        <input ref={fileRef} type={'file'} style={{display: 'none'}} onChange={e => {
          if (files?.length > 2) {
            alert('파일은 3개까지만 등록할 수 있습니다.')
            return
          }
          const file_ = e?.target.files[0]
          if (file_?.size > 50 * 1024 * 1024) {
            alert('파일 용량은 50MB 이하로 업로드 해주세요.')
            return
          }
          files.push(file_)
          setFiles(Object.assign([], files))
        }}/>
        <img className={'icon-32'} src={require('../assets/images/attachment.png')}/>
      </div>
      <div className={'margin-top-40'}>
        <div className={'white font-16'}>{msg}</div>
        <div className={'more-blur-white font-16 margin-top-10'}>{desc}</div>
      </div>
      <div className={'margin-top-20'}>
        {files?.map((item, index) => {
          return (
            <div className={'white font-14 margin-left-20'}>{item?.name}</div>
          )
        })}
      </div>
    </div>
  )
}

const ModalComponent = ({setModalOpen}) => {

  const [mouseOver, setMouseOver] = useState(false);

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [field, setField] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [agreePrivacy, setAgreePrivacy] = useState(false)
  const [agreeSensitive, setAgreeSensitive] = useState(false)
  const [files, setFiles] = useState([]);
  const fileRef = useRef()
  const [agreePrivacyOnCareerTitle, setAgreePrivacyOnCareerTitle] = useState('')
  const [agreePrivacyOnCareer, setAgreePrivacyOnCareer] = useState('')
  const [agreeSensitiveOnCareerTitle, setAgreeSensitiveOnCareerTitle] = useState('')
  const [agreeSensitiveOnCareer, setAgreeSensitiveOnCareer] = useState('')

  const saveCareer = () => {
    if (!name) {
      alert('성명을 입력해 주세요.')
      return
    }

    if(!validatePhone(phone)) {
      alert('연락처는 숫자만 입력해주세요.')
      return
    }

    if (!email || !validateEmail(email)) {
      alert('올바른 이메일을 입력해 주세요.')
      return
    }

    if (!agreePrivacy) {
      alert('개인정보 수집 및 이용 동의해 주세요.')
      return
    }

    if(!files?.length) {
      alert('이력서 또는 포트폴리오를 업로드 해주세요.')
      return
    }

    sendRequest('career/career/', 'POST', {
      name,
      phone,
      email,
      field,
      title,
      description,
      agreePrivacy,
      agreeSensitive
    }, data => {
      if (files?.length) {
        const formData = new FormData();
        formData.append('file1', files[0])
        if(files?.length > 1) {
          formData.append('file2', files[1])
        }
        if(files?.length > 2) {
          formData.append('file3', files[2])
        }
        sendFormRequest(`career/career-file/${data?.id}/`, 'POST', formData, data => {
          setModalOpen(false)
        })
      } else {
        setModalOpen(false)
      }
    })

    alert('채용 지원이 올바르게 신청 되었습니다.')
  }

  const getConfig = () => {
    sendRequest('config/config/?key=agreePrivacyOnCareer', 'GET', null, data => {
      const agreement = data[0]
      setAgreePrivacyOnCareerTitle(agreement?.value)
      setAgreePrivacyOnCareer(agreement?.desc)
    })

    sendRequest('config/config/?key=agreeSensitiveOnCareer', 'GET', null, data => {
      const agreement = data[0]
      setAgreeSensitiveOnCareerTitle(agreement?.value)
      setAgreeSensitiveOnCareer(agreement?.desc)
    })
  }

  useEffect(() => {
    getConfig()
  }, [])

  return (
    <div className={'portfolio-modal-wrapper darkgray-bg'}>
      <div className={'absolute'} style={{right: '2vw', top: '4vh'}}>
        <div onClick={() => setModalOpen(false)}
             onMouseEnter={() => setMouseOver(true)}
             onMouseLeave={() => setMouseOver(false)}
        >
          <img className={'icon-36'} src={require('../assets/images/cancel.png')}/>
        </div>
      </div>
      <div className={'relative flex-center'} style={{marginTop: -5}}>
        <div className={'absolute flex-column'} style={{top: '3vw'}}>
          <div className={'career-box flex-column'}>
            <div className={'white notosans-black font-30 whiter-border-bottom padding-bottom-40'}>지원자정보</div>
            <div className={'margin-top-54'}>
              <div className={'flex-row'}>
                <div className={'flex-1'}>
                  <TextInput placeholder={'성명'} value={name} setValue={setName} backgroundColor={'#252525'}/>
                </div>
                <div className={'flex-1'} style={{marginLeft: '3.5vw'}}>
                  <TextInput placeholder={'연락처'} value={phone} setValue={setPhone} backgroundColor={'#252525'}/>
                </div>
              </div>ㅡ
            </div>
            <div className={'margin-top-32'}>
              <div className={'flex-row'}>
                <div className={'flex-1'}>
                  <TextInput placeholder={'이메일'} value={email} setValue={setEmail} backgroundColor={'#252525'}/>
                </div>
                <div className={'flex-1'} style={{marginLeft: '3.5vw'}}>
                  <TextInput placeholder={'지원분야'} value={field} setValue={setField} backgroundColor={'#252525'}/>
                </div>
              </div>
            </div>
            <div className={'margin-top-32'}>
              <TextInput
                placeholder={'제목'}
                backgroundColor={'#252525'}
                value={title}
                setValue={setTitle}
              />
            </div>
            <div className={'margin-top-32'}>
              <TextInput
                placeholder={'내용'}
                backgroundColor={'#fff'}
                height={219}
                padding={'20px 0 0 20px'}
                width={'calc(100% - 20px)'}
                multiline={true}
                value={description}
                setValue={setDescription}
              />
            </div>

            <div className={'margin-top-40 file-input-wrapper align-center'}>
              <FileInput fileRef={fileRef} files={files} setFiles={setFiles} msg={'이력서와 포트폴리오는 PDF 파일로 업로드 부탁드립니다.(50MB 이하)'}
                         desc={'*이력서 내 주민등록번호 뒷자리는 필수 삭제 후 최소한의 개인정보 업로드'}/>
            </div>

            <div className={'margin-top-40 flex-row'}>
              <div className={'flex-1 flex-column'}>
                <div className={'flex-row'} onClick={() => setAgreePrivacy(!agreePrivacy)}>
                  <img className={'icon-22'}
                       src={agreePrivacy ? require('../assets/images/checkbox_on.png') : require('../assets/images/checkbox.png')}/>
                  <div className={`${agreePrivacy ? 'white' : 'gray'} notosans-bold font-20 margin-left-16`}>
                    <span className={''}>{agreePrivacyOnCareerTitle}</span>
                  </div>
                </div>
                <div className={'agreement pre-wrap'}>
                  {agreePrivacyOnCareer}
                </div>
              </div>
              <div className={'flex-1 flex-column margin-left-20'}>
                <div className={'flex-row'} onClick={() => setAgreeSensitive(!agreeSensitive)}>
                  <img className={'icon-22'}
                       src={agreeSensitive ? require('../assets/images/checkbox_on.png') : require('../assets/images/checkbox.png')}/>
                  <div className={`${agreeSensitive ? 'white' : 'gray'} notosans-bold font-20 margin-left-16`}>
                    <span className={''}>{agreeSensitiveOnCareerTitle}</span>
                  </div>
                </div>
                <div className={'agreement pre-wrap'}>
                  {agreeSensitiveOnCareer}
                </div>
              </div>
            </div>

            <div className={'flex-center margin-top-80 margin-bottom-80'}>
              <img className={'career-btn'} src={require('../assets/images/career/save_btn.png')} onClick={saveCareer}/>
              {/*<Button text={'지원서 제출'} width={197} height={69} onClick={saveCareer}/>*/}
            </div>
          </div>

          {/*<div className={'width-100 flex-start flex-column margin-top-32'}>*/}
          {/*  <div className={'more-blur-white font-14 notosans-regular text-left'} style={{lineHeight: 1.6}}>*/}
          {/*    * 휘닉스커뮤니케이션즈는 채용절차법에 의거하여 공정하고 객관적인 채용 절차를 진행합니다.<br/>*/}
          {/*    * 휘닉스커뮤니케이션즈는 역량이 있는 분들을 수시로 모시고 있습니다.<br/>*/}
          {/*    * 이력서를 등록해 주시면 검토 후 개별 연락을 드리겠습니다.<br/>*/}
          {/*    <br/>*/}
          {/*    * 전형 절차는 직무별로 다르게 운영될 수 있으며, 일정 및 상황에 따라 변동될 수 있습니다.<br/>*/}
          {/*    * 채용 전형 절차 종료 후 지원자의 동의하에 평판조회가 진행될 수 있습니다.<br/>*/}
          {/*  </div>*/}
          {/*  <div className={'flex-row margin-top-40'}>*/}
          {/*    <div className={'more-blur-white font-14 notosans-regular text-left'}>*/}
          {/*      채용 관련 문의 &nbsp;recruit@pci.co.kr*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
      </div>
    </div>
  )
}

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '0%',
    width: '100vw',
    height: '100%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#252525',
    zIndex: 9999,
    position: 'relative',
    overflow: 'auto'
  },
};

export const Career = ({}) => {

  const [modalOpen, setModalOpen] = useState(false);

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [field, setField] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [agreePrivacy, setAgreePrivacy] = useState(false)
  const [agreeSensitive, setAgreeSensitive] = useState(false)
  const [files, setFiles] = useState([]);
  const fileRef = useRef()
  const [agreePrivacyOnCareerTitle, setAgreePrivacyOnCareerTitle] = useState('')
  const [agreePrivacyOnCareer, setAgreePrivacyOnCareer] = useState('')
  const [agreeSensitiveOnCareerTitle, setAgreeSensitiveOnCareerTitle] = useState('')
  const [agreeSensitiveOnCareer, setAgreeSensitiveOnCareer] = useState('')

  const saveCareer = () => {
    if (!name) {
      alert('성명을 입력해 주세요.')
      return
    }

    if(!validatePhone(phone)) {
      alert('연락처는 숫자만 입력해 주세요.')
      return
    }

    if (!email || !validateEmail(email)) {
      alert('올바른 이메일을 입력해 주세요.')
      return
    }

    if (!agreePrivacy) {
      alert('개인정보 수집 및 이용 동의해 주세요.')
      return
    }

    if(!files?.length) {
      alert('이력서 또는 포트폴리오를 업로드 해주세요.')
      return
    }

    sendRequest('career/career/', 'POST', {
      name,
      phone,
      email,
      field,
      title,
      description,
      agreePrivacy,
      agreeSensitive
    }, data => {
      if (files?.length) {
        const formData = new FormData();
        formData.append('file1', files[0])
        if(files?.length > 1) {
          formData.append('file2', files[1])
        }
        if(files?.length > 2) {
          formData.append('file3', files[2])
        }
        sendFormRequest(`career/career-file/${data?.id}/`, 'POST', formData, (data) => {
          setModalOpen(false)
        })
      } else {
        setModalOpen(false)
      }
    })

    alert('채용 지원이 올바르게 신청 되었습니다.')
  }

  const getConfig = () => {
    sendRequest('config/config/?key=agreePrivacyOnCareer', 'GET', null, data => {
      const agreement = data[0]
      setAgreePrivacyOnCareerTitle(agreement?.value)
      setAgreePrivacyOnCareer(agreement?.desc)
    })

    sendRequest('config/config/?key=agreeSensitiveOnCareer', 'GET', null, data => {
      const agreement = data[0]
      setAgreeSensitiveOnCareerTitle(agreement?.value)
      setAgreeSensitiveOnCareer(agreement?.desc)
    })
  }

  useEffect(() => {
    getConfig()
    window.scroll(0, 0)
    savePageVisit('Career')
  }, [])

  return (
    <div>
      {modalOpen ? null : <Header/>}
      {isPc ?
        <div style={{marginTop: 80}}>
          {/*<div className={'relative black-bg width-100-vw'}>*/}
            {/*<img className={'width-100-vw'} src={require('../assets/images/career/career1_bg.png')}/>*/}
            {/*<div className={'absolute margin-left-32 padding-bottom-80'} style={{zIndex: 2, top: 0, left: 0}}>*/}
            {/*  /!*<img className={'margin-top-80'} style={{width: '40vw'}} src={require('../assets/images/career/careers.png')}/>*!/*/}
            {/*  <div className={'margin-top-80 bebas-kai white title no-letter-spacing'}>CAREERS</div>*/}

            {/*  <div className={'margin-top-80 text-start'}>*/}
            {/*    <div className={'white font-24 notosans-bold'} style={{lineHeight: 1.8}}>*/}
            {/*      성장을 꿈꾸는 기업과 인재들이<br/>*/}
            {/*      항상 함께 일하고 싶은 마케팅 솔루션 기업*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</div>*/}
            {/*<img className={'width-100'} src={require('../assets/images/career1_bg.png')}/>*/}
            {/*<div className={'absolute flex-center flex-column width-100'} style={{top: '15vw'}}>*/}
            {/*<div className={'flex-row'}>*/}
            {/*  <img style={{width: '20vw'}} src={require('../assets/images/logo.png')}/>*/}
            {/*  <div className={'bebas-kai white'} style={{fontSize: '3.5vw', marginTop: '2vw'}}>CAREERS</div>*/}
            {/*</div>*/}
            {/*  <div className={'margin-top-40 text-center'} style={{lineHeight: 1.8}}>*/}
            {/*    <div className={'white font-30 notosans-regular'}>성장을 꿈꾸는 기업과 인재들이</div>*/}
            {/*    <div className={'white font-30 notosans-black'}>항상 함께 일하고 싶은<br/> 마케팅 솔루션 기업</div>*/}
            {/*  </div>*/}

            {/*  <div style={{marginTop: '3vw'}}>*/}
            {/*    <div className={'flex-row'}>*/}
            {/*      <div className={'white-border notosans-bold'}>*/}
            {/*        #신뢰*/}
            {/*      </div>*/}
            {/*      <div className={'white-border notosans-bold'} style={{marginLeft: 60}}>*/}
            {/*        #열정*/}
            {/*      </div>*/}
            {/*      <div className={'white-border notosans-bold'} style={{marginLeft: 60}}>*/}
            {/*        #성장*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</div>*/}
          {/*</div>*/}

          <div className={'relative width-100-vw'} style={{overflow: 'hidden'}}>
            <img className={'absolute width-100-vw'} style={{top: 0, left: 0, height: 'auto'}}
                 src={require('../assets/images/career/career_bg2.png')}/>
            <div className={'relative flex-column margin-bottom-40'} style={{padding: '3vh 5vh 0 5vh'}}>
              <div className={'padding-bottom-80'} style={{zIndex: 2}}>
                <div className={'margin-top-40 bebas-kai white title no-letter-spacing'}>CAREERS</div>

                <div className={'margin-top-80 text-start'}>
                  <div className={'white font-24 notosans-bold'} style={{lineHeight: 1.8}}>
                    성장을 꿈꾸는 기업과 인재들이<br/>
                    항상 함께 일하고 싶은 마케팅 솔루션 기업
                  </div>
                </div>
              </div>

              <div className={'align-end font-40 poppins-bold white margin-top-40'}>Core value</div>

              <Fade direction={'left'}>
                <div className={'margin-top-24 align-end flex-column'}>
                  {/*<img style={{height: '15vw'}} src={require('../assets/images/career/credibility.png')}/>*/}
                  <div className={'bebas-kai white title no-letter-spacing'}>CREDIBILITY</div>
                  <div className={'font-24 grayC notosans-bold margin-top-10'}>신뢰를 기반으로</div>
                </div>
              </Fade>
              <Fade direction={'left'}>
                <div className={'margin-top-24 align-end flex-column'}>
                  {/*<img style={{height: '15vw'}} src={require('../assets/images/career/growth.png')}/>*/}
                  <div className={'bebas-kai white title no-letter-spacing'}>GROWTH</div>
                  <div className={'font-24 grayC notosans-bold margin-top-10'}>함께 성장하며</div>
                </div>
              </Fade>
              <Fade direction={'left'}>
                <div className={'margin-top-24 align-end flex-column'}>
                  {/*<img style={{height: '15vw'}} src={require('../assets/images/career/passion.png')}/>*/}
                  <div className={'bebas-kai white title no-letter-spacing'}>PASSION</div>
                  <div className={'font-24 grayC notosans-bold margin-top-10'}>열정으로 일하는</div>
                </div>
              </Fade>
              <Fade direction={'left'}>
                <div className={'margin-top-40 align-center'}>
                  <img style={{width: 'calc(100vw - 160px)'}} src={require('../assets/images/career/career_step.png')}/>
                </div>
              </Fade>

              <div className={'align-center margin-top-40 margin-bottom-60'}>
                <img
                  onClick={() => setModalOpen(true)}
                  className={'career-btn'}
                  src={require('../assets/images/career/apply_btn.png')}
                />
              </div>
            </div>
          </div>

          <Modal
            isOpen={modalOpen}
            // onAfterOpen={afterOpenModal}
            onRequestClose={() => setModalOpen(false)}
            style={customStyles}
            contentLabel="Example Modal"
          >
            <ModalComponent setModalOpen={setModalOpen}/>
          </Modal>

          {/*<div className={'relative'} style={{marginTop: -5}}>*/}
          {/*  <img className={'width-100'} src={require('../assets/images/career2_bg.png')}/>*/}
          {/*  <div className={'absolute'} style={{left: '3vw', top: '10vw'}}>*/}
          {/*    <Fade direction={'left'}>*/}
          {/*    <img style={{height: '14.5vw'}} src={require('../assets/images/career2_text_1.png')}/>*/}
          {/*    </Fade>*/}
          {/*  </div>*/}
          {/*  <div className={'absolute'} style={{left: '3vw', top: '32vw'}}>*/}
          {/*    <Fade direction={'bottom-left'}>*/}
          {/*      <img style={{height: '14.5vw'}} src={require('../assets/images/career2_text_2.png')}/>*/}
          {/*    </Fade>*/}
          {/*  </div>*/}
          {/*  <div className={'absolute'} style={{left: '3vw', top: '54vw'}}>*/}
          {/*    <Fade direction={'right'}>*/}
          {/*      <img style={{height: '14.5vw'}} src={require('../assets/images/career2_text_3.png')}/>*/}
          {/*    </Fade>*/}
          {/*  </div>*/}

          {/*  <div className={'absolute flex-center width-100'} style={{top: '74vw'}}>*/}
          {/*    <div className={'flex-row'}>*/}
          {/*      <div className={'white-border notosans-bold'}>*/}
          {/*        #신뢰*/}
          {/*      </div>*/}
          {/*      <div className={'white-border notosans-bold'} style={{marginLeft: 60}}>*/}
          {/*        #열정*/}
          {/*      </div>*/}
          {/*      <div className={'white-border notosans-bold'} style={{marginLeft: 60}}>*/}
          {/*        #성장*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}

          {/*<div className={'relative white-bg'} style={{marginTop: -5}}>*/}
          {/*  <img className={'width-100'} src={require('../assets/images/process_bg.png')}/>*/}
          {/*  <div className={'absolute flex-center width-100 font-40 notosans-bold'} style={{top: '6.5vw'}}>영입 절차</div>*/}
          {/*  <div className={'absolute flex-center width-100 flex-row'} style={{top: '12vw'}}>*/}
          {/*    <Fade direction={'left'}>*/}
          {/*      <div className={'flex-1'}>*/}
          {/*        <img style={{width: '15vw'}} src={require('../assets/images/career/career1.png')}/>*/}
          {/*      </div>*/}
          {/*    </Fade>*/}
          {/*    <Fade direction={'bottom-left'}>*/}
          {/*      <div className={'flex-1 relative'} style={{marginLeft: '-2vw'}}>*/}
          {/*        <img style={{width: '15vw'}} src={require('../assets/images/career/career2.png')}/>*/}
          {/*        <div className={'absolute'} style={{left: '7.3vw', bottom: '-9.5vw'}}>*/}
          {/*          <img style={{height: '13vw'}} src={require('../assets/images/career/vertical_line.png')}/>*/}
          {/*          <div*/}
          {/*            className={'font-20 notosans-light'}*/}
          {/*            style={{margin: '-2vw 0 0 1vw', width: 300, color: 'rgba(0, 0, 0, 0.4)'}}>*/}
          {/*            전문 직무 역량 심층 검증*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*    </Fade>*/}
          {/*    <Fade direction={'up'}>*/}
          {/*      <div className={'flex-1'} style={{marginLeft: '-2vw'}}>*/}
          {/*        <img style={{width: '15vw'}} src={require('../assets/images/career/career3.png')}/>*/}
          {/*      </div>*/}
          {/*    </Fade>*/}
          {/*    <Fade direction={'bottom-right'}>*/}
          {/*      <div className={'flex-1 relative'} style={{marginLeft: '-2vw'}}>*/}
          {/*        <img style={{width: '15vw'}} src={require('../assets/images/career/career4.png')}/>*/}
          {/*        <div className={'absolute'} style={{left: '7.3vw', bottom: '-9vw'}}>*/}
          {/*          <img style={{height: '12vw'}} src={require('../assets/images/career/vertical_line.png')}/>*/}
          {/*          <div*/}
          {/*            className={'font-20 notosans-light'}*/}
          {/*            style={{margin: '-2vw 0 0 1vw', width: 300, color: 'rgba(0, 0, 0, 0.4)'}}>*/}
          {/*            임원 면접*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*    </Fade>*/}
          {/*    <Fade direction={'right'}>*/}
          {/*      <div className={'flex-1'} style={{marginLeft: '-2vw'}}>*/}
          {/*        <img style={{width: '15vw'}} src={require('../assets/images/career/career5.png')}/>*/}
          {/*      </div>*/}
          {/*    </Fade>*/}
          {/*  </div>*/}
          {/*</div>*/}


        </div>
        :
        <div className={'relative black-bg width-100'} style={{marginTop: 80, width: SCREEN_WIDTH}}>
          {/*<div className={'relative'} style={{paddingBottom: 100}}>*/}
            {/*<div className={'flex-center'} style={{paddingTop: 100}}>*/}
            {/*  <div className={'flex-column flex-center'}>*/}
            {/*  <img style={{width: '60vw'}} src={require('../assets/images/logo.png')}/>*/}
            {/*    <div className={'bebas-kai white'} style={{fontSize: '24vw', marginTop: '0'}}>CAREERS</div>*/}
            {/*  </div>*/}
            {/*</div>*/}

            {/*<div className={'margin-top-40 text-center'} style={{lineHeight: 1.8}}>*/}
            {/*  <div className={'white font-24 notosans-regular'}>성장을 꿈꾸는 기업과 인재들이</div>*/}
            {/*  <div className={'white font-24 notosans-black'}>항상 함께 일하고 싶은<br/>마케팅 솔루션 기업</div>*/}
            {/*</div>*/}

            {/*<div className={'width-100 align-center'}>*/}
            {/*  <div className={'flex-column'}>*/}
            {/*    <div className={'mobile-white-border notosans-bold margin-top-40'}>*/}
            {/*      #신뢰*/}
            {/*    </div>*/}
            {/*    <div className={'mobile-white-border notosans-bold margin-top-40'}>*/}
            {/*      #열정*/}
            {/*    </div>*/}
            {/*    <div className={'mobile-white-border notosans-bold margin-top-40'}>*/}
            {/*      #성장*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</div>*/}
          {/*</div>*/}
          <div className={'relative'}>
            <img className={'width-100'} style={{height: '140vh'}} src={require('../assets/images/career/career_bg.png')}/>
            <div className={'absolute'} style={{left: '6vw', top: '3vh'}}>
              <div className={'bebas-kai white'} style={{fontSize: '24vw', marginTop: '0'}}>CAREERS</div>
              <div style={{lineHeight: 1.8, marginTop: '1vh'}}>
                <div className={'white font-20 notosans-regular'}>성장을 꿈꾸는 기업과 인재들이</div>
                <div className={'white font-20 notosans-black'}>항상 함께 일하고 싶은<br/>마케팅 솔루션 기업</div>
              </div>
            </div>
            <div className={'absolute'} style={{right: '10vw', top: '43vh'}}>
              <div className={'align-end font-20 poppins-bold white'}>Core value</div>
            </div>
            <div className={'absolute'} style={{right: '10vw', top: '52vh'}}>
              <Fade direction={'up'}>
                <img style={{height: '26vw'}} src={require('../assets/images/career/credibility.png')}/>
              </Fade>
            </div>
            <div className={'absolute'} style={{right: '10vw', top: '73vh'}}>
              <Fade direction={'right'}>
                <img style={{height: '26vw'}} src={require('../assets/images/career/growth.png')}/>
              </Fade>
            </div>
            <div className={'absolute'} style={{right: '10vw', top: '95vh'}}>
              <Fade direction={'bottom-right'}>
                <img style={{height: '26vw'}} src={require('../assets/images/career/passion.png')}/>
              </Fade>
            </div>

            <div className={'absolute'} style={{right: '0vw', top: '105vh'}}>
              <Fade direction={'left'}>
                <div className={'margin-top-80 align-end'}>
                  <img style={{width: '100%'}} src={require('../assets/images/career/career_step.png')}/>
                </div>
              </Fade>
            </div>

              {/*<div className={'absolute width-100 align-center'} style={{top: '96vw'}}>*/}
              {/*  <div className={'flex-column'}>*/}
              {/*    <div className={'mobile-white-border notosans-bold margin-top-40'}>*/}
              {/*      #신뢰*/}
              {/*    </div>*/}
              {/*    <div className={'mobile-white-border notosans-bold margin-top-40'}>*/}
              {/*      #열정*/}
              {/*    </div>*/}
              {/*    <div className={'mobile-white-border notosans-bold margin-top-40'}>*/}
              {/*      #성장*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*</div>*/}
            </div>

          {/*<div className={'relative'}>*/}
            {/*<img className={'width-100'} src={require('../assets/images/mobile/mobile_career3.png')}/>*/}
          {/*</div>*/}

          <div className={'relative flex-center flex-column black-bg'} style={{marginTop: 0}}>
            <div className={'mobile-career-box'}>
              <div className={'white notosans-black font-30 align-center'}>지원자정보</div>
              <div className={'margin-top-32'}>
                <div className={'padding-20'}>
                  <div className={'blur-white font-16'}>성명</div>
                  <div className={'padding-vertical-20'}>
                    <TextInput placeholder={''} fontSize={16} width={SCREEN_WIDTH - (isIOS() ? 92 : 76)} value={name} setValue={setName} />
                  </div>
                </div>
                <div className={'padding-20'}>
                  <div className={'blur-white font-16'}>연락처</div>
                  <div className={'padding-vertical-10'}>
                    <TextInput placeholder={''} fontSize={16} width={SCREEN_WIDTH - (isIOS() ? 92 : 76)} value={phone} setValue={setPhone} />
                  </div>
                </div>
                <div className={'padding-20'}>
                  <div className={'blur-white font-16'}>이메일</div>
                  <div className={'padding-vertical-10'}>
                    <TextInput placeholder={''} fontSize={16} width={SCREEN_WIDTH - (isIOS() ? 92 : 76)} value={email} setValue={setEmail} />
                  </div>
                </div>
                <div className={'padding-20'}>
                  <div className={'blur-white font-16'}>지원분야</div>
                  <div className={'padding-vertical-10'}>
                    <TextInput placeholder={''} fontSize={16} width={SCREEN_WIDTH - (isIOS() ? 92 : 76)} value={field} setValue={setField} />
                  </div>
                </div>
                <div className={'padding-20'}>
                  <TextInput
                    placeholder={'제목'}
                    titleFontSize={16}
                    // backgroundColor={'#272727'}
                    // width={SCREEN_WIDTH - 80}
                    height={44}
                    fontSize={16}
                    padding={'1px 0 0 0'}
                    value={title}
                    setValue={setTitle}
                  />
                </div>
                <div className={'padding-20'}>
                  <TextInput
                    placeholder={'내용'}
                    backgroundColor={'#272727'}
                    width={SCREEN_WIDTH - 92}
                    height={219}
                    fontSize={16}
                    padding={'20px 0 0 20px'}
                    multiline={true}
                    value={description}
                    setValue={setDescription}
                  />
                </div>

                <div className={'margin-20 mobile-file-input-wrapper'}>
                  <MobileFileInput fileRef={fileRef} files={files} setFiles={setFiles} msg={'이력서와 포트폴리오는 PDF 파일로\n 업로드 부탁드립니다.'} desc={'*이력서 내 주민등록번호 뒷자리는 필수 삭제 후 최소한의 개인정보 업로드'}/>
                </div>

                <div className={'padding-20'}>
                  <div className={'flex-1 flex-column'}>
                    <div className={'flex-row'} onClick={() => setAgreePrivacy(!agreePrivacy)}>
                      <img className={'icon-32'}
                           src={agreePrivacy ? require('../assets/images/checkbox_on.png') : require('../assets/images/checkbox.png')}/>
                      <div className={`${agreePrivacy ? 'white' : 'gray'} notosans-bold font-18 margin-left-16`}>
                        <span className={'underline'}>{agreePrivacyOnCareerTitle}</span>
                      </div>
                    </div>
                    <div className={'more-blur-white mobile-agreement pre-wrap'}>
                      {agreePrivacyOnCareer}
                    </div>
                  </div>
                  <div className={'flex-1 flex-column margin-top-32'}>
                    <div className={'flex-row'} onClick={() => setAgreeSensitive(!agreeSensitive)}>
                      <img className={'icon-32'}
                           src={agreeSensitive ? require('../assets/images/checkbox_on.png') : require('../assets/images/checkbox.png')}/>
                      <div className={`${agreeSensitive ? 'white' : 'gray'} notosans-bold font-18 margin-left-16`}>
                        <span className={'underline'}>{agreeSensitiveOnCareerTitle}</span>
                      </div>
                    </div>
                    <div className={'more-blur-white mobile-agreement pre-wrap'}>
                      {agreeSensitiveOnCareer}
                    </div>
                  </div>
                </div>

                <div className={'align-center padding-20'}>
                  {/*<Button text={'지원서 제출'} width={SCREEN_WIDTH - 72} height={69} onClick={saveCareer}/>*/}
                  <img className={'career-btn'} src={require('../assets/images/career/save_btn.png')}
                       onClick={saveCareer}/>
                </div>
              </div>
            </div>

            {/*<div className={'flex-start flex-column padding-horizontal-40'}>*/}
            {/*  <div className={'more-blur-white font-14 notosans-regular text-left'} style={{lineHeight: 1.8}}>*/}
            {/*    * 휘닉스커뮤니케이션즈는 채용절차법에 의거하여<br/>*/}
            {/*    &nbsp;&nbsp;&nbsp;공정하고 객관적인 채용 절차를 진행합니다.<br/>*/}
            {/*    * 휘닉스커뮤니케이션즈는 역량이 있는 분들을<br/>*/}
            {/*    &nbsp;&nbsp;&nbsp;수시로 모시고 있습니다.<br/>*/}
            {/*    * 이력서를 등록해 주시면 검토 후 개별 연락을 드리겠습니다.<br/>*/}
            {/*    <br/>*/}
            {/*    * 전형 절차는 직무별로 다르게 운영될 수 있으며, 일정 및 상황에 따라 변동될 수 있습니다.<br/>*/}
            {/*    * 채용 전형 절차 종료 후 지원자의 동의하에 평판조회가 진행될 수 있습니다.<br/>*/}
            {/*  </div>*/}
            {/*  <div className={'more-blur-white font-14 notosans-regular text-left margin-top-40'} style={{lineHeight: 1.8}}>*/}
            {/*    채용 관련 문의  recruit@pci.co.kr*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>
        </div>
      }
      <div className={'relative'}>
        <Footer/>
      </div>
</div>
)
}
